import { deepCopy } from "../../../../../utils/deepCopy"
import { toast } from "../../../../../utils/messageUtils"

export const addOpenEndedQuestions = (state, payload) => {
    let goals = addOpenEndedQuestionsToGoals(state, payload)
    return {
        ...state,
        goals: goals
    }
}

const addOpenEndedQuestionsToGoals = (state, payload) => {
    let goalsCopy = deepCopy(state.goals)
    goalsCopy.forEach(item => {
        if (item.goalId === "comments") {
            item.questions.splice(item.questions.length, 0, payload.data)
        }
    })
    toast.success("Question added successfully")
    return goalsCopy
}